import * as Connector from 'shared/connectors/investorsConnector';
import { INVESTOR } from 'store/types';

const init = () => ({
  type: INVESTOR.GET_ARCHIVED_INVESTORS_INIT,
});

export const success = data => ({
  type: INVESTOR.GET_ARCHIVED_INVESTORS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: INVESTOR.GET_ARCHIVED_INVESTORS_FAILURE,
});

const getArchivedInvestors = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getArchivedInvestors();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getArchivedInvestors;
